import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, Mail } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, errorText } from "@/lib/api";
import { Field, Panel } from "@/components/admin/shared";

const EmailLog = ({ refresh }) => {
  const [log, setLog] = useState([]);
  useEffect(() => { api.get("/admin/email-log").then((r) => setLog(r.data.slice(0, 5))).catch(() => {}); }, [refresh]);
  if (!log.length) return null;
  return (
    <ul className="mt-6 space-y-2 text-sm" data-testid="email-log-list">
      {log.map((l) => (
        <li key={l.id} className="flex flex-wrap gap-2 border-b border-line pb-2">
          <span className={l.status === "enviado" ? "font-semibold text-green" : "font-semibold text-red-600"}>{l.status === "enviado" ? "Enviado" : "Error"}</span>
          <span className="text-ink2">{l.subject}</span>
          <span className="text-mute">{new Date(l.created_at).toLocaleString("es-MX")}{l.status !== "enviado" && ` · ${l.detail}`}</span>
        </li>
      ))}
    </ul>
  );
};

export const EmailAlertPanel = ({ settings, save }) => {
  const [a, setA] = useState(settings.email_alert);
  const [testing, setTesting] = useState(false);
  const [tick, setTick] = useState(0);
  const test = async () => {
    setTesting(true);
    try { await api.post("/admin/email-alert/test"); toast.success(`Correo de prueba enviado a ${a.to}`); } catch (e) { toast.error(errorText(e)); }
    setTesting(false); setTick(tick + 1);
  };
  return (
    <Panel title="Aviso por correo de citas nuevas">
      <p className="mb-4 flex gap-2 text-sm text-mute"><Mail size={16} className="mt-0.5 shrink-0 text-brand" /> Cada vez que un cliente agende en el sitio te llega un correo con su nombre, teléfono, servicio, fecha y hora. Si el correo falla, la cita se guarda igual y la ves aquí en el panel.</p>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field id="email-alert-to" label="Correo que recibe los avisos" type="email" value={a.to} onChange={(e) => setA({ ...a, to: e.target.value })} />
        <label className="flex items-center gap-3 self-end pb-2 text-sm"><Switch checked={a.enabled} onCheckedChange={(v) => setA({ ...a, enabled: v })} data-testid="email-alert-enabled" /> Enviar aviso por correo</label>
      </div>
      <div className="mt-6 flex flex-wrap gap-3">
        <button className="btn-gold" onClick={async () => { const d = await save({ email_alert: a }); if (d) setA(d.email_alert); }} data-testid="email-alert-save-btn">Guardar correo</button>
        <button className="btn-ghost" onClick={test} disabled={testing} data-testid="email-alert-test-btn"><Send size={16} /> Enviar correo de prueba</button>
      </div>
      <EmailLog refresh={tick} />
    </Panel>
  );
};
